export const MOBILE_WIDTH = 768
export const TABLET_WIDTH = 960
export const SMALL_DESKTOP_WIDTH = 1240
